import React from 'react';
import './ProjectHandover.css';

export default function ProjectHandover() {
  return (
    <div className="project-handover-wrapper">
      <div className="form-modal-overlay">
        <div className="form-modal-content">
          <div className="form-cover-wrapper">
            <div className="form-page-cover-image-wrapper">
              <img 
                src="https://www.jotform.com/uploads/emilyandrus0918/form_files/Strike-PANTONE%20Transparent%204.688b781431baa4.40188992.png" 
                alt="STRIKE - Project Handover Package Logo" 
                className="form-page-cover-image"
              />
            </div>
          </div>
          
          <div className="handover-content">
            <h1 className="form-header">Project Handover Package</h1>
            <p className="form-description">
              Complete the project handover form to submit all necessary documentation and information for project transition.
            </p>
            
            <div className="button-container">
              <a 
                href="https://form.jotform.com/261526980887170"
                target="_blank" 
                rel="noopener noreferrer"
                className="jotform-button"
              >
                Open Handover Form
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
